<div class = "admin-carrefs">

  <div class="carrefs-menu">
    <a [routerLink]="'/admin/carrefs/manufacturers'">
      Constructeurs
    </a>

    <br />
    <a [routerLink]="'/admin/carrefs/makes'">
      Marques
    </a>

    <a [routerLink]="'/admin/carrefs/models'">
      Modèles
    </a>

    <a [routerLink]="'/admin/carrefs/versions'">
      Versions
    </a>

    <br />
    <a [routerLink]="'/admin/carrefs/engines'">
      Moteurs
    </a>

    <a [routerLink]="'/admin/carrefs/features'">
      Features
    </a>

    <br />
    <a [routerLink]="'/admin/carrefs/job-tasks'">
      Taches
    </a>

    <a [routerLink]="'/admin/carrefs/job-templates'">
      Templates
    </a>
  </div>

  <div class="carrefs-content">

    @if (selected==CarRefItemCode.MAN) {
      <app-carref-manufacturers
        [manufacturers]="(manufs$ | async)!"
        >
      </app-carref-manufacturers>
    }

    @if (selected==CarRefItemCode.MAK) {
      <app-carref-makes
        [manufacturers]="(manufs$ | async)!"
        [makes]="(makes$ | async)!"
        >
      </app-carref-makes>
    }

    @if (selected==CarRefItemCode.MOD) {
      <app-carref-models
        [makes]="(makes$ | async)!"
        [models]="(models$ | async)!"
        [engines]="(engines$ | async)!"
        [features]="(features$ | async)!"
        >
      </app-carref-models>
    }

    @if (selected==CarRefItemCode.VER) {
      <app-carref-versions
        [makes]="(makes$ | async)!"
        [models]="(models$ | async)!"
        [versions]="(versions$ | async)!"
        [engines]="(engines$ | async)!"
        [features]="(features$ | async)!"
        >
      </app-carref-versions>
    }

    @if (selected==CarRefItemCode.ENG) {
      <app-carref-engines
        [manufacturers]="(manufs$ | async)!"
        [engines]="(engines$ | async)!"
        >
      </app-carref-engines>
    }

    @if (selected==CarRefItemCode.FEA) {
      <app-carref-features
        [features]="(features$ | async)!"
        >
      </app-carref-features>
    }


    @if (selected==CarRefItemCode.JTE) {
      <app-carref-job-templates
        [jobTemplates]="(jobTemplates$ | async)!"
        [jobTasks]="(jobTasks$ | async)!"
        >
      </app-carref-job-templates>
    }

    @if (selected==CarRefItemCode.JTA) {
      <app-carref-job-tasks
        [jobTasks]="(jobTasks$ | async)!"
        >
      </app-carref-job-tasks>
    }

  </div>
</div>
